/* eslint-disable react/no-unused-prop-types */
/* eslint-disable sonarjs/no-unused-collection */
/* eslint-disable no-useless-return */
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import { useLocation } from "react-router-dom";
import AutocompleteFloatLabel from "../../../components/AutocompleteFloatLabel";
import DialogMessage from "../../../components/DialogMessage";
import DialogMessageProps from "../../../model/DialogMessageProps";
import Cartao from "../../../model/dto/Cartao";
import { TipoCartaoEnum } from "../../../model/Enums/TipoCartaoEnum";
import { TypeDialogMessageEnum } from "../../../model/Enums/TypeDialogMessageEnum";
import SelectOption from "../../../model/SelectOption";
import CartoesService from "../../../service/Docente/CartoesService";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import GenericUtils from "../../../utils/GenericUtils";
import Professor from "../../../model/dto/Professor";
import InputCalendarStyles from "../../../styles/components/InputCalendarStyles";
import StringUtils from "../../../utils/types/StringUtils";
import { MASK_DATE } from "../../../utils/constants";
import { Routes } from "../../../model/Enums/RoutesEnum";
import ModalJustificativa from "./ModalJustifyHrExtra";
import ProfessorService from "../../../service/Docente/ProfessorService";
import SporadicActivity from "../../../model/dto/SporadicActivity";
import PaginationModel from "../../../model/dto/PaginationModel";
import {
    StatusCheckinEnum,
    StatusCheckinEnumLabel,
} from "../../../model/Enums/StatusCheckinEnum";

const { BtnPrimary } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

interface IFormAvulsoProps {
    matriculaAdp: string;
    docente: Professor;
    onCreate: (typeCard: TipoCartaoEnum) => void;
    dataInicioSemana: string;
    dataFimSemana: string;
    typeCard: string | number;
}

function FormAvulso(props: IFormAvulsoProps) {
    const { typeCard } = props;
    const { instance } = useMsal();

    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);

    const [activity, setActivity] = useState(new Array<SelectOption>());
    const [activityOptions, setActivityOptions] = useState(
        new Array<SelectOption>()
    );
    const [numberHours, setNumberHours] = useState(new Array<SelectOption>());
    const [isModalJustificativa, setIsModalJustificativa] = useState(false);
    const [numberHoursOptions, setNumberHoursOptions] = useState(
        new Array<SelectOption>()
    );
    const [datePicker, setDatePicker] = useState<any>(null);
    const location = useLocation();
    const pathLocation = location.pathname.split("/");

    const isFormValid = !!activity.length && !!numberHours.length;

    const getAtividades = async () => {
        const { docenteID } = props.docente;

        if (!docenteID) return;

        const response =
            await ProfessorService.getSporadicActivitiesByDocenteId(
                instance,
                docenteID
            );

        if (GenericUtils.isSuccessStatus(response)) {
            const page = response.data as PaginationModel<SporadicActivity>;
            setActivityOptions(
                page.itens.map((item: SporadicActivity) => {
                    return GenericUtils.impl<SelectOption>({
                        value: item.atividadeId.toString(),
                        label: item.descricao,
                    });
                })
            );
        } else {
            setActivityOptions([]);
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const handleSubmit = async (justfication: string) => {
        setIsModalJustificativa(false);
        if (!isFormValid) return;
        let cartao: Cartao = {};
        if (typeCard === `${TipoCartaoEnum.HoraExtraTela}`) {
            cartao = {
                titulo: activity[0]?.label,
                cartaoTipo: {
                    cartaoTipoId: TipoCartaoEnum.HoraExtraTela,
                },
                duracaoHoraAula: Number(numberHours[0]?.value),
                duracaoHoraRelogio: numberHours[0]?.value === "60" ? 45 : 22,
                statusCheckin: StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.AguardandoCheckin
                ),
                dataInicioVigencia: StringUtils.formatDateString(
                    datePicker?.toISOString(),
                    MASK_DATE
                ),
                dataFimVigencia: StringUtils.formatDateString(
                    datePicker?.toISOString(),
                    MASK_DATE
                ),
                docenteId: props.docente.docenteID,
                justificativa: justfication,
            };
        } else {
            cartao = {
                titulo: activity[0]?.label,
                cartaoTipo: {
                    cartaoTipoId: TipoCartaoEnum.AtividadesAvulsas,
                },
                duracaoHoraAula: Number(numberHours[0]?.value),
                duracaoHoraRelogio: numberHours[0]?.value === "60" ? 45 : 22,
                origemCartaoId: Number(activity[0]?.value),
                statusCheckin: StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.AguardandoCheckin
                ),
                dataInicioVigencia: props.dataInicioSemana,
                dataFimVigencia: props.dataFimSemana,
                docenteId: props.docente.docenteID,
                cartaoTipoOrigem: {
                    cartaoTipoId: TipoCartaoEnum.HoraNaoLetiva,
                    cartaoTipoNome: "HORA NÃO LETIVA - MATRIZ CURRICULAR",
                    entidadeTabelaNome: "DBO.HORA_NAO_LETIVA",
                },
            };
        }

        const response = await CartoesService.salvarCartao(instance, cartao);
        if (GenericUtils.isSuccessStatus(response)) {
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Success,
                title: "Cartão salvo com sucesso",
            });
        } else {
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const handleCreate = async () => {
        if (
            typeCard === `${TipoCartaoEnum.HoraExtraTela}` &&
            pathLocation[1] === Routes.EditarAgenda
        ) {
            setIsModalJustificativa(true);
        } else {
            handleSubmit("");
        }
    };

    const handleClose = () => {
        setIsModalJustificativa(false);
    };

    const dialogJustify = (
        <ModalJustificativa
            open={isModalJustificativa}
            onSubimit={(justificativa: string) => {
                handleSubmit(justificativa);
            }}
            onClose={() => {
                handleClose();
            }}
        />
    );

    const handleCloseDialogMessage = () => {
        if (dialogMessageProps.type === TypeDialogMessageEnum.Success)
            props.onCreate(TipoCartaoEnum.AtividadesAvulsas);

        setDialogMessageProps({} as DialogMessageProps);
    };

    const getNumbersOption = () => {
        return [
            GenericUtils.impl<SelectOption>({
                value: "30",
                label: "0.5",
            }),
            GenericUtils.impl<SelectOption>({
                value: "60",
                label: "1",
            }),
        ];
    };

    useEffect(() => {
        setNumberHoursOptions(getNumbersOption());
        getAtividades();
    }, []);

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={handleCloseDialogMessage}
        />
    );
    return (
        <>
            <Row>
                <Col>
                    <AutocompleteFloatLabel
                        label="Selecione a atividade"
                        options={activityOptions}
                        selected={activity}
                        onChange={setActivity}
                        labelSecondary
                        className="modal-create-card-autocomplete"
                    />
                </Col>
            </Row>
            {typeCard === `${TipoCartaoEnum.HoraExtraTela}` && (
                <Row className="mb-4">
                    <Col>
                        <InputCalendarStyles.StyledCalendar
                            placeholder="Data da atividade"
                            dateFormat="dd/mm/yy"
                            locale="pt-BR"
                            autoZIndex
                            touchUI
                            readOnlyInput
                            showButtonBar
                            value={datePicker}
                            onChange={(e: any) =>
                                setDatePicker(e.target?.value)
                            }
                        />
                    </Col>
                </Row>
            )}
            <Row>
                <Col>
                    <AutocompleteFloatLabel
                        label="Quantidade Hora/Aula"
                        options={numberHoursOptions}
                        selected={numberHours}
                        onChange={setNumberHours}
                        className="modal-create-card-autocomplete"
                    />
                </Col>
            </Row>
            {dialogJustify}
            <StyledContainerButton className="mt-3">
                <BtnPrimary disabled={!isFormValid} onClick={handleCreate}>
                    Criar
                </BtnPrimary>
            </StyledContainerButton>
            {dialogMessage}
        </>
    );
}

export default FormAvulso;
